import { LiveLikePrediction } from "@livelike/engagementsdk";
import "../image-prediction-option";
import "./sbs-image-prediction.css";
const html = (window as any).html;
export const imagePredictionVotes = {};
class SBSImagePrediction extends LiveLikePrediction {
  @((window as any).property({ type: Object })) optionSelected = {
    id: undefined,
  };

  @((window as any).property({ type: Boolean })) isExpired = false;

  connectedCallback() {
    super.connectedCallback();
    const interactiveUntil: string = this.widgetPayload.interactive_until;
    this.isExpired = interactiveUntil
      ? Date.now() > new Date(interactiveUntil).getTime()
      : false;
  }

  optionSubmitted = () => {
    this.submitVote(this.optionSelected);
  };

  setOptionSelected = (option: any) => {
    this.optionSelected = option;
  };

  firstUpdated() {
    super.firstUpdated();
    this.updateComplete.then(() => {
      if (this.interaction) {
        this.disabled = true;
      }
    });
    this.addEventListener("prediction", (e: any) => {
      //@ts-ignore
      imagePredictionVotes[e.detail.widget.id] = {
        option_id: e.detail.prediction.option_id,
        claim_token: e.detail.prediction.claim_token,
      };
    });
  }

  submitVote = (option: any) => {
    if (!this.disabled && option.id !== this.selectedOption.id) {
      this.selectedOption = option;

      this.interactionEvent();
    }
  };
  lockInVote = () => {
    //@ts-ignore
    if (!this.disabled && this.optionSelected?.id) {
      this.voteDisable = true;
      //@ts-ignore
      this.createVote(this.optionSelected.vote_url).then(() => {
        this.voteDisable = true;
        this.disabled = true;
      });
    }
  };

  render() {
    return html`
      <template kind="text-prediction" id="custom-prediction">
        <livelike-widget-root class="custom-widget">
          <livelike-widget-header class="widget-header" slot="header">
            <livelike-title class="custom-title"></livelike-title>
          </livelike-widget-header>
          <livelike-widget-body>
            <livelike-select
              class="${this.widgetPayload.options.length === 3
                ? "sbs-3x1"
                : ""}"
            >
              <template>
                <sbs-image-prediction-option
                  .setOptionSelected=${this.setOptionSelected}
                >
                </sbs-image-prediction-option>
              </template>
            </livelike-select>
            <livelike-footer>
              <button
                class="widget-button ${this.optionSelected.id
                  ? "selected"
                  : ""}"
                @click=${this.lockInVote}
                ?disabled=${this.disabled}
              >
                ${!this.disabled
                  ? "submit"
                  : this.isExpired && this.interaction
                  ? "submitted"
                  : this.isExpired
                  ? "Expired"
                  : "submitted"}
              </button>
            </livelike-footer>
          </livelike-widget-body>
        </livelike-widget-root>
      </template>
    `;
  }
}

customElements.define("sbs-image-prediction", SBSImagePrediction as any);
